// Include main stylesheet (which is including bootstrap in a custom way)
//import 'masonry-layout';
window.Masonry = require('masonry-layout');

import "bootstrap";
import "bootstrap-select";
import "bootstrap-select";
import "jquery-visible";
import 'hc-sticky';

require('../sass/main.scss');

import 'slick-carousel';

require('./load.js');
require('./filters.js');
require('./click.js');
require('./forms.js');
require('./gsap-effects.js');
require('./maps.js');
require('./swiped-events.js');



// Focus on search field if exsiting
window.onload = () => {
    var searchInput = document.getElementById('search-field')
    if(searchInput) {
        searchInput.focus()
    }

    if($('.grid').length){
        var msnry = new Masonry( '.grid', {
            //columnWidth: 200,
            gutter: 32,
            itemSelector: '.card'
        });
    }

    if($('#sitemap .sitemap-sub').length){
        var msnry = new Masonry( '#sitemap', {
            //columnWidth: 200,
            gutter: 32,
            itemSelector: '.sitemap-sub'
        });
    }

    if($('.mtsnb').length > 0){
        $('#main-nav').hcSticky({
            stickTo: $('#main-content'),
            top: $('.mtsnb').hasClass('mtsnb-hidden') ? 0 : $('.mtsnb').height(),
        });
    }else{
        $('#main-nav').hcSticky({
            stickTo: $('#main-content'),
            top: 0,
        });
    }

    $('.mtsnb-hide').on('click',function(){
        // mainmenuSticky.refresh({});
        console.log($('#main-nav').hcSticky('options'));
        $('#main-nav').hcSticky('update',{top:0});
        console.log($('#main-nav').hcSticky('options'));
        // $('#main-nav').hcSticky('destroy');
        // $('#main-nav').hcSticky({
        //     stickTo: $('#main-content'),
        //     top: 0,
        // });
    });
}



var checkScroll = function() {
    var scroll = $(window).scrollTop();
    if (!$('#footer').visible(true)) {
        $('#footer-stick').addClass('scrolling');
    } else {
        $('#footer-stick').removeClass('scrolling');
    }        
}
$(window).scroll(function() {
    checkScroll();
});
checkScroll();

/* Uploaded files in forms - remove before upload */
$('.form-control-file').change( function(event) {
    var fileName = $(this).val().match(/[^\\/]*$/)[0];
    $('.uploadedFile', $(this).closest('.wpcf7-form-control-wrap')).remove();
    $(this).closest('.wpcf7-form-control-wrap').append('<div class="uploadedFile">'+ fileName +'<a class="removeFile" href="#" title="Remove"><i class="fa fa-times-circle"></i></a></div>');
});
$(document).on("click",".removeFile", function(e){
    e.preventDefault();
    $(this).closest('.wpcf7-form-control-wrap').find('input[type="file"]').val('')
    $(this).parent().remove();
});

$(document).ready(function(){

    // Scroll on click in arrow on carousel home
    $('.scroll-down').on('click', function() {
        var cube_margin = 340;
        if(window.matchMedia("(max-width: 991.98px)").matches){
            cube_margin = 180;
        }
        console.log(cube_margin);
        $('html, body').animate({ scrollTop: $('.full-content .block:nth-child(2)').offset().top - (cube_margin + 150) }, 1000); // we add more margin to offset as to not stick to top of page
    })

    $('.block-comparatif #columns > div').on('click', function(){
        $('.block-comparatif #columns > div.selected').removeClass('selected');
        $(this).addClass('selected');
    });

    $('.slider-poc').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slider-poc-image',
        appendArrows: '.slider-poc-controls',
        focusOnSelect: true,
        nextArrow: '<span class="fa-stack fa-lg slick-next"><i class="far fa-circle fa-stack-2x"></i><i class="fas fa-arrow-right fa-stack-1x"></i></span>',
        prevArrow: '<span class="fa-stack fa-lg slick-next"><i class="far fa-circle fa-stack-2x"></i><i class="fas fa-arrow-left fa-stack-1x"></i></span>',
    });
    $('.slider-poc-image').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.slider-poc',
        responsive: [
            {
              breakpoint: 768,
              settings: {
                dots: true,
              }
            },
        ]
    });

    $('.slider-timeline').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '.slider-timeline-controls',
        dots: true,
        nextArrow: '<span class="fa-stack fa-lg slick-next"><i class="far fa-circle fa-stack-2x"></i><i class="fas fa-arrow-right fa-stack-1x"></i></span>',
        prevArrow: '<span class="fa-stack fa-lg slick-next"><i class="far fa-circle fa-stack-2x"></i><i class="fas fa-arrow-left fa-stack-1x"></i></span>',
        responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
              }
            },
        ]
    });

    $('.mise-en-avant-service-list').slick({
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1.25,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick'
            }
        ]
    });

    var sliderNumber = $('.slider-logos').data( "number" );
    $('.slider-logos').slick({
        arrows: true,
        infinite: true,
        slidesToShow: sliderNumber,
        slidesToScroll: 1,
        appendArrows: '.slider-logos-controls',
        nextArrow: '<span class="fa-stack fa-lg slick-next"><i class="far fa-circle fa-stack-2x"></i><i class="fas fa-arrow-right fa-stack-1x"></i></span>',
        prevArrow: '<span class="fa-stack fa-lg slick-next"><i class="far fa-circle fa-stack-2x"></i><i class="fas fa-arrow-left fa-stack-1x"></i></span>',
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                autoplay: true,
                slidesToShow: 2,
                arrows: false,
              }
            },
        ]
    });
})